export const isBodyVisible = function(body, selectionMode, mode) {
  const bodyFixedForSelection = selectionMode == "selected" && (body.selected || body.anyPositionSelected)
  return Boolean((body.filtered || mode) && (bodyFixedForSelection || selectionMode == "all"))
}
export const isHeaderVisible = function(header, selectionMode, mode) {
  const headerHasAnyBodySelectedOrWithPositionSelected = header.bodies.some(b => b.anyPositionSelected || b.selected)
  return Boolean((header.filtered || mode)
    && (selectionMode === "all" || header.selected || headerHasAnyBodySelectedOrWithPositionSelected))
}